import React from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import Article from "./Article";
import { Element } from "react-scroll";
import {
    getSectionAnchorId,
    getSubSections,
} from "../../../redux/selectors/sections";
import {
    getReactStyleSectionHeader,
    getSubSectionTitleStyling,
    shouldIncludeSectionArticleCount,
} from "../../../redux/selectors/template";
import { ArticleBreakLine } from "./BreakLines";

/**
 * Component to display one newsletter section
 * @param props
 * @returns {*}
 * @constructor
 */
const NewsletterSection = (props) => {
    const {
        id,
        section,
        sectionAnchorId,
        sectionTitleStyleObject,
        shouldShowArticleCount,
    } = props;

    const numArticles = _get(section, "giList.length", 0);
    let title = section.name;

    if (shouldShowArticleCount) {
        title += ` (${numArticles})`;
    }

    return (
        <Element name={sectionAnchorId}>
            <div className="newsletter-section" data-section-id={id}>
                <div className="section-title" style={sectionTitleStyleObject}>
                    {title}
                </div>

                <div className="section-articles">
                    {section.giList.map((id, index) => (
                        <div key={id}>
                            <Article id={id} sectionId={section.id} />

                            {index < numArticles - 1 && <ArticleBreakLine />}
                        </div>
                    ))}

                    {/*<pre>{JSON.stringify(section, null, 2)}</pre>*/}
                </div>

                <SubSections props={props} />
            </div>
        </Element>
    );
};

/**
 * loop sub sections to output corresponding articles
 * @param  {} props - contains subsection data/metadata
 * @return {React Element}
 */
const SubSections = ({ props }) => {
    const { subSections, subSectionTitleStyle } = props;

    if (subSections && subSections.length) {
        return (
            <React.Fragment>
                {subSections.map((subSection, index) => (
                    <Element
                        name={`section_${subSection.groupingSectionId}`}
                        key={index}
                    >
                        <div className="newsletter-sub-section">
                            <div
                                className="sub-section-title"
                                style={subSectionTitleStyle}
                            >
                                {subSection.name}
                            </div>

                            <div className="section-articles">
                                {subSection.giList.map((giId, index) => (
                                    <React.Fragment key={giId}>
                                        <Article id={giId} />

                                        {index <
                                            subSection.giList.length - 1 && (
                                            <ArticleBreakLine />
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </Element>
                ))}
            </React.Fragment>
        );
    } else {
        return null;
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapStateToProps = (state, ownProps) => {
    //const {newsletters} = state;

    const { id } = ownProps;

    return {
        sectionAnchorId: getSectionAnchorId(state, id),
        sectionTitleStyleObject: getReactStyleSectionHeader(state),
        subSections: getSubSections(state, id),
        subSectionTitleStyle: getSubSectionTitleStyling(state),
        shouldShowArticleCount: shouldIncludeSectionArticleCount(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterSection);
